import { Link } from 'react-router-dom';
import './AppLinkButton.scss';

interface Props {
    buttonClassName?: string;
    link: string;
    buttonText: string;
    isBorderColor?: boolean;
    isBorderRounded?: boolean;
    isHover?: boolean;
}

const AppLinkButton = ({
    buttonClassName,
    link,
    buttonText,
    isBorderColor = true,
    isBorderRounded = true,
    isHover = true,
}: Props) => {
    return (
        <Link
            className={`
                link-button
                ${buttonClassName}
                ${isBorderColor ? 'border-color' : ''}
                ${isBorderRounded ? 'border-rounded' : ''}
                ${isHover ? 'hover-effect' : ''}
            `}
            to={link}
        >
            {buttonText}
        </Link>
    );
};

export default AppLinkButton;
